<c-card class="referral-link-card">
  <c-card-body>
    <div class="referral-link-container">
      <div class="referral-link-label">
        <svg cIcon name="cilLinkAlt" size="lg"></svg>
        <span>{{ 'referral_link_label' | translate }}</span>
      </div>

      <div class="referral-link-actions">
        <div class="referral-url-display">
          @if (referralUrl) {
            <code>{{ referralUrl }}</code>
          } @else {
            <span class="loading-text">{{ 'referral_link_loading' | translate }}</span>
          }
        </div>

        <button
          cButton
          color="secondary"
          size="sm"
          class="btn-copy"
          (click)="copyToClipboard()"
          [disabled]="!referralUrl"
          [attr.aria-label]="'referral_link_copy' | translate"
        >
          <svg cIcon name="cilDocument"></svg>
          <span>{{ copied() ? ('referral_link_copied' | translate) : ('referral_link_copy' | translate) }}</span>
        </button>

        <button
          cButton
          color="primary"
          size="sm"
          class="btn-open"
          (click)="openInNewWindow()"
          [disabled]="!referralUrl"
          [attr.aria-label]="'referral_link_open' | translate"
        >
          <svg cIcon name="cilActionRedo"></svg>
          <span>{{ 'referral_link_open' | translate }}</span>
        </button>
      </div>
    </div>
  </c-card-body>
</c-card>